var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "custom-class": "layout-dialog",
        title: "商品明細",
        top: "5vh",
        visible: _vm.dialogVisible,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.close,
      },
    },
    [
      _c(
        "div",
        { staticClass: "dialog-main-div" },
        [
          _c(
            "vab-query-form",
            {
              attrs: {
                model: _vm.queryForm,
                "enable-query-save": false,
                size: "mini",
                "label-position": "right",
                "label-width": "160px",
              },
              on: { search: _vm.onSearch },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c("el-form-item", { attrs: { label: "商品" } }, [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _vm.goodslists.length == 1
                                  ? _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.goodslists[0].code,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.goodslists[0],
                                            "code",
                                            $$v
                                          )
                                        },
                                        expression: "goodslists[0].code",
                                      },
                                    })
                                  : _vm.goodslists.length > 1
                                  ? _c("el-input", {
                                      attrs: { value: "<複数>", disabled: "" },
                                    })
                                  : _c("el-input", {
                                      attrs: { value: "", disabled: "" },
                                    }),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              {
                                staticStyle: { "margin-left": "20px" },
                                attrs: { span: 16 },
                              },
                              [
                                _vm.goodslists.length == 1
                                  ? _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.goodslists[0].title,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.goodslists[0],
                                            "title",
                                            $$v
                                          )
                                        },
                                        expression: "goodslists[0].title",
                                      },
                                    })
                                  : _vm.goodslists.length > 1
                                  ? _c("el-input", {
                                      attrs: { value: "<複数>", disabled: "" },
                                    })
                                  : _c("el-input", {
                                      attrs: { value: "", disabled: "" },
                                    }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 2 } },
                    [
                      _c(
                        "el-popover",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.goodslists.length > 1,
                              expression: "goodslists.length > 1",
                            },
                          ],
                          attrs: { placement: "bottom", trigger: "click" },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                data: _vm.goodslists,
                                border: "",
                                stripe: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  width: "80",
                                  property: "code",
                                  label: "商品CD",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  width: "120",
                                  property: "title",
                                  label: "商品名",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("el-button", {
                            staticStyle: { "margin-top": "10px" },
                            attrs: {
                              slot: "reference",
                              size: "mini",
                              type: "primary",
                              icon: "el-icon-more",
                            },
                            slot: "reference",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 18 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品明細名CD" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.queryForm.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "code", $$v)
                              },
                              expression: "queryForm.code",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 18 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品明細名(半角ｶﾅ)" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.queryForm.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "title", $$v)
                              },
                              expression: "queryForm.title",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "vab-list-body" },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("vab-table", {
                    ref: "table",
                    attrs: {
                      "api-url": "/goodDetails/list",
                      columns: _vm.columns,
                      "custom-config": false,
                      "multi-select": _vm.multiSelect,
                      height: "300",
                      "query-params": _vm.queryForm,
                    },
                    on: {
                      "update:queryParams": function ($event) {
                        _vm.queryForm = $event
                      },
                      "update:query-params": function ($event) {
                        _vm.queryForm = $event
                      },
                      "selection-change": _vm.setSelectRows,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v("確定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }